import React from 'react';

import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

import { useExternalJobBoardsState, useExternalJobBoardsActions } from './ExternalJobBoardsContext';

import { updateExternalJobBoard } from './restApi';

const UpdateExternalJobBoardForm = () => {
  const externalJobBoardsState = useExternalJobBoardsState();
  const { onResponse, onError, updateUpdateExternalJobBoardUrl, closeUpdateExternalJobBoardModal } = useExternalJobBoardsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    updateExternalJobBoard({
      onResponse,
      onError,
      body: {
        authenticityToken,
        updateExternalJobBoard: externalJobBoardsState?.updateExternalJobBoard,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="URL" id="external_job_board_url">
        <Input
          type="url"
          value={externalJobBoardsState?.updateExternalJobBoard?.url || ''}
          onChange={(e) => {
            updateUpdateExternalJobBoardUrl(e.target.value);
          }}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              closeUpdateExternalJobBoardModal();
            }}
          >
            Cancel
          </Button>
          <Button type="submit">
            Update
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default UpdateExternalJobBoardForm;
